import { SignIn } from '@clerk/clerk-react';

const clerkAppearance = {
  variables: {
    colorPrimary: '#0d9488',           // teal-600
    colorTextOnPrimaryBackground: '#f0f9ff',
    colorBackground: 'rgba(8, 47, 73, 0.45)',
    colorInputBackground: 'rgba(224, 242, 254, 0.12)',
    colorInputText: '#e0f2fe',
    colorText: '#bae6fd',              // sky-200
    colorTextSecondary: '#7dd3fc',     // sky-300
    colorNeutral: '#164e63',           // cyan-900
    borderRadius: '0.75rem',
  },
  elements: {
    card: {
      background: 'rgba(7, 42, 66, 0.50)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      border: '1px solid rgba(125, 211, 252, 0.2)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
    },
    headerTitle: {
      color: '#7dd3fc',                // sky-300
      textShadow: '0 1px 8px rgba(0,0,0,0.5)',
    },
    headerSubtitle: {
      color: '#a5f3fc',                // cyan-200
    },
    formFieldLabel: {
      color: '#67e8f9',                // cyan-300
    },
    formFieldInput: {
      background: 'rgba(224, 242, 254, 0.08)',
      border: '1px solid rgba(103, 232, 249, 0.3)',
      color: '#e0f2fe',
      '&::placeholder': { color: '#7dd3fc88' },
    },
    formButtonPrimary: {
      background: 'linear-gradient(135deg, #0e7490, #0d9488)',
      color: '#f0f9ff',
      '&:hover': { background: 'linear-gradient(135deg, #155e75, #0f766e)' },
    },
    footerActionLink: {
      color: '#2dd4bf',                // teal-400
    },
    identityPreviewText: {
      color: '#bae6fd',
    },
    dividerLine: {
      background: 'rgba(125, 211, 252, 0.2)',
    },
    dividerText: {
      color: '#7dd3fc',
    },
  },
};

export default function HomePage() {
  return (
    <div
      className="flex min-h-screen items-center justify-center"
      style={{
        backgroundImage: 'url(/anchor_backdrop.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <SignIn routing="hash" appearance={clerkAppearance} />
    </div>
  );
}
